// Le rendu du markdown restreint (markdown.ts) en éléments React : paragraphes, listes, gras.
// Jamais de `dangerouslySetInnerHTML` : chaque morceau est un nœud de texte, une balise écrite
// dans un texte s'affiche telle quelle.
import { Fragment } from 'react'
import { analyserMarkdown, type Segment } from './markdown'

function Segments({ s }: { s: Segment[] }) {
  return <>{s.map((x, i) => (x.gras ? <strong key={i}>{x.texte}</strong> : <Fragment key={i}>{x.texte}</Fragment>))}</>
}

export default function TexteMarkdown({ source, className }: { source: string; className?: string }) {
  const blocs = analyserMarkdown(source)
  return (
    <div className={className ?? 'abs-md'}>
      {blocs.map((b, i) => (b.type === 'p'
        ? <p key={i}><Segments s={b.segments} /></p>
        : <ul key={i}>{b.items.map((it, k) => <li key={k}><Segments s={it} /></li>)}</ul>))}
    </div>
  )
}
